var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { Flex } from '@finect/tabular-core/Flex';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1gpnzn9-0"
})(["", ""], function (_ref) {
  var _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? false : _ref$marginTop;
  return marginTop ? 'margin-top: 9px;' : '';
});
var largeTitleStyles = css(["", ""], function (_ref2) {
  var $compact = _ref2.$compact;
  return getFont(3 - ($compact ? 1 : 0), 'xcompact');
});
var mediumTitleStyles = css(["", ""], function (_ref3) {
  var $compact = _ref3.$compact;
  return getFont(2 - ($compact ? 1 : 0), 'xcompact');
});
var smallTitleStyles = css(["", ""], function (_ref4) {
  var $compact = _ref4.$compact;
  return getFont(1 - ($compact ? 1 : 0), 'xcompact');
});
export var InnerBlock = styled.div.withConfig({
  displayName: "partials__InnerBlock",
  componentId: "sc-1gpnzn9-1"
})(["&:not(:last-child){margin-bottom:24px;}", ""], maxMediaQueries.tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", " {\n      ", "\n    }\n  "])), Flex, function (_ref5) {
  var $variantId = _ref5.$variantId;
  return ['medium', 'large'].includes($variantId) ? 'display:block;' : '';
}));
export var InnerArticle = styled.div.withConfig({
  displayName: "partials__InnerArticle",
  componentId: "sc-1gpnzn9-2"
})(["", " ", "  ", " ", ""], function (_ref6) {
  var imagePosition = _ref6.imagePosition;
  return imagePosition === 'up' && 'display: flex;flex-direction: column;';
}, function (_ref7) {
  var imagePosition = _ref7.imagePosition;
  return imagePosition === 'left' && "\n    display: grid; \n    grid-template-columns: repeat(2, 1fr);\n    gap: 48px;\n  ";
}, maxMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref8) {
  var imagePosition = _ref8.imagePosition;
  return imagePosition === 'left' && 'gap: 18px;';
}), maxMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref9) {
  var imagePosition = _ref9.imagePosition;
  return imagePosition === 'left' && 'grid-template-columns: 1fr; gap: 12px;';
}));
var smallImageBlockStyles = css(["flex-shrink:0;"]);
export var ImageFigure = styled.figure.withConfig({
  displayName: "partials__ImageFigure",
  componentId: "sc-1gpnzn9-3"
})(["display:block;flex-shrink:0;width:100%;height:100%;", " background-color:", ";margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;img{width:100%;height:100%;", ";inset:0;object-fit:cover;}"], function (_ref10) {
  var $variantId = _ref10.$variantId;
  return $variantId === 'small' ? smallImageBlockStyles : '';
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.uiL;
}, function (_ref12) {
  var _ref12$imageRoundBord = _ref12.imageRoundBorder,
    imageRoundBorder = _ref12$imageRoundBord === void 0 ? true : _ref12$imageRoundBord;
  return imageRoundBorder && "border-radius: 8px;";
});
export var ImageLink = styled.a.withConfig({
  displayName: "partials__ImageLink",
  componentId: "sc-1gpnzn9-4"
})([""]);
var imageLargeStyles = css(["width:320px;margin-right:24px;"]);
export var ImageColumnBlock = styled.div.withConfig({
  displayName: "partials__ImageColumnBlock",
  componentId: "sc-1gpnzn9-5"
})(["flex-shrink:0;", " ", ""], function (_ref13) {
  var imagePosition = _ref13.imagePosition,
    $variantId = _ref13.$variantId;
  return imagePosition === 'left' && $variantId === 'large' && imageLargeStyles;
}, function (_ref14) {
  var imagePosition = _ref14.imagePosition,
    $variantId = _ref14.$variantId,
    imageFormat = _ref14.imageFormat;
  return imagePosition === 'left' && $variantId === 'small' && css(["width:", "px;margin-right:12px;", ""], imageFormat === 'square' ? '90' : '120', imageFormat === 'square' ? 'height: 90px;' : '');
});
var withAuthorImageStyles = css(["display:block;", " ", "{width:56px;height:56px;margin-bottom:9px;}"], maxMediaQueries.tablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  "]))), ImageColumnBlock);
export var ContentBlock = styled.div.withConfig({
  displayName: "partials__ContentBlock",
  componentId: "sc-1gpnzn9-6"
})(["", " ", ""], function (_ref15) {
  var withAuthorImage = _ref15.withAuthorImage;
  return withAuthorImage && withAuthorImageStyles;
}, function (_ref16) {
  var withAuthorImage = _ref16.withAuthorImage;
  return !withAuthorImage ? 'display: flex;' : '';
});
export var AspectRatioContainer = styled.div.withConfig({
  displayName: "partials__AspectRatioContainer",
  componentId: "sc-1gpnzn9-7"
})(["position:relative;width:100%;padding-top:", "%;"], function (_ref17) {
  var _ref17$ratio = _ref17.ratio,
    ratio = _ref17$ratio === void 0 ? 9 / 16 : _ref17$ratio;
  return ratio * 100;
});
export var AspectRatioContent = styled.div.withConfig({
  displayName: "partials__AspectRatioContent",
  componentId: "sc-1gpnzn9-8"
})(["position:absolute;top:0;bottom:0;left:0;right:0;"]);
export var OrderColumnBlock = styled.div.withConfig({
  displayName: "partials__OrderColumnBlock",
  componentId: "sc-1gpnzn9-9"
})(["order:1;", ""], function (_ref18) {
  var spaceBetween = _ref18.spaceBetween;
  return spaceBetween && css(["display:flex;flex-direction:column;justify-content:space-between;"]);
});
export var DateBlock = styled.div.withConfig({
  displayName: "partials__DateBlock",
  componentId: "sc-1gpnzn9-10"
})(["flex-shrink:0;color:", ";", ""], function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.fontL;
}, getFont(-1));
export var BottomBlock = styled.div.withConfig({
  displayName: "partials__BottomBlock",
  componentId: "sc-1gpnzn9-11"
})(["display:flex;align-items:center;flex-wrap:wrap;", "{", "}", " ", ""], DateBlock, function (_ref20) {
  var withAuthor = _ref20.withAuthor;
  return withAuthor && css(["&:before{display:inline-block;padding:0 5px;content:'\u2022';color:", ";}"], function (_ref21) {
    var theme = _ref21.theme;
    return theme.colors.primaryL;
  });
}, minMediaQueries.tablet(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["margin-top: 4px; margin-bottom: 4px;"]))), maxMediaQueries.tablet(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["margin-top: 8px; margin-bottom: 8px;"]))));
export var ArticleTitle = styled.h3.withConfig({
  displayName: "partials__ArticleTitle",
  componentId: "sc-1gpnzn9-12"
})(["display:inline-block;color:", ";", " ", " ", "   ", " ", " ", " ", " &:hover{text-decoration:underline;}"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.colors.terciaryD;
}, function (_ref23) {
  var $variantId = _ref23.$variantId;
  return $variantId === 'large' ? largeTitleStyles : '';
}, function (_ref24) {
  var $variantId = _ref24.$variantId;
  return $variantId === 'medium' ? mediumTitleStyles : '';
}, function (_ref25) {
  var $variantId = _ref25.$variantId;
  return $variantId === 'small' ? smallTitleStyles : '';
}, function (_ref26) {
  var $fontSize = _ref26.$fontSize,
    $compact = _ref26.$compact;
  return $fontSize ? getFont($fontSize - ($compact ? 1 : 0), 'xcompact') : '';
}, function (_ref27) {
  var $lineHeight = _ref27.$lineHeight;
  return $lineHeight ? "line-height: ".concat($lineHeight, ";") : '';
}, function (_ref28) {
  var _ref28$$fontWeight = _ref28.$fontWeight,
    $fontWeight = _ref28$$fontWeight === void 0 ? 700 : _ref28$$fontWeight;
  return $fontWeight ? "font-weight: ".concat($fontWeight, ";") : '';
}, function (_ref29) {
  var $withTopMargin = _ref29.$withTopMargin;
  return $withTopMargin ? 'margin-top: 12px;' : '';
});
export var ArticleDescription = styled.div.withConfig({
  displayName: "partials__ArticleDescription",
  componentId: "sc-1gpnzn9-13"
})(["", " margin-top:6px;color:", ";ul{padding-left:12px;li:before{display:inline-block;margin-right:6px;content:'\u2022';vertical-align:sub;font-size:36px;line-height:1;color:", ";}}a{color:", ";}", " ", " ", ""], getFont(0), function (_ref30) {
  var theme = _ref30.theme;
  return theme.colors.fontL;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.colors.secondary;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.linkColor;
}, function (_ref33) {
  var $variantId = _ref33.$variantId;
  return $variantId === 'small' && css(["", ""], getFont(-1, 'compact'));
}, maxMediaQueries.tablet(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["display: none;"]))), maxMediaQueries.phablet(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["display: block;"]))));
export var TagsBlock = styled.div.withConfig({
  displayName: "partials__TagsBlock",
  componentId: "sc-1gpnzn9-14"
})(["margin-bottom:4px;"]);
export var TagLink = styled.a.withConfig({
  displayName: "partials__TagLink",
  componentId: "sc-1gpnzn9-15"
})(["color:currentColor;"]);
var linkStyles = css(["transition:color 0.25s ease;&:hover{color:", ";}"], function (_ref34) {
  var theme = _ref34.theme;
  return theme.linkColor;
});
export var AuthorBlock = styled.div.withConfig({
  displayName: "partials__AuthorBlock",
  componentId: "sc-1gpnzn9-16"
})(["display:flex;align-items:center;color:", ";", ""], function (_ref35) {
  var theme = _ref35.theme;
  return theme.colors.fontL;
}, function (_ref36) {
  var withLink = _ref36.withLink;
  return withLink && linkStyles;
});
export var AuthorName = styled.div.withConfig({
  displayName: "partials__AuthorName",
  componentId: "sc-1gpnzn9-17"
})(["max-width:180px;", " ", " ", " ", " ", " ", ""], textEllipsis, getFont(-1), function (_ref37) {
  var withOrganization = _ref37.withOrganization;
  return withOrganization && css(["display:inline;font-weight:600;color:", ";"], function (_ref38) {
    var theme = _ref38.theme;
    return theme.colors.font;
  });
}, function (_ref39) {
  var withOrganization = _ref39.withOrganization;
  return !withOrganization && css(["color:", ";"], function (_ref40) {
    var theme = _ref40.theme;
    return theme.colors.fontL;
  });
}, function (_ref41) {
  var _ref41$withOrganizati = _ref41.withOrganizationImage,
    withOrganizationImage = _ref41$withOrganizati === void 0 ? false : _ref41$withOrganizati;
  return withOrganizationImage && css(["", " ", " font-weight:600;color:", ";"], getFont(0), maxMediaQueries.miniDesktop(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ""])), getFont(-1)), function (_ref42) {
    var theme = _ref42.theme;
    return theme.colors.uiDD;
  });
}, function (_ref43) {
  var authorHasProfile = _ref43.authorHasProfile;
  return authorHasProfile && css(["&:hover{color:", ";}"], function (_ref44) {
    var theme = _ref44.theme;
    return theme.colors.primary;
  });
});
export var OrganizationName = styled.div.withConfig({
  displayName: "partials__OrganizationName",
  componentId: "sc-1gpnzn9-18"
})(["font-weight:500;", " ", ""], textEllipsis, getFont(-1));
export var AuthorPartial = styled.div.withConfig({
  displayName: "partials__AuthorPartial",
  componentId: "sc-1gpnzn9-19"
})(["width:auto;margin-top:6px;", " font-weight:700;a,span{display:flex;flex-direction:row;align-items:center;color:currentColor;}.author{color:", ";font-weight:500;}"], getFont(-2, 'compact'), function (_ref45) {
  var theme = _ref45.theme;
  return theme.colors.primary;
});